///<reference path="../common/data-template-base.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;
    import Variant = Model.Variant;
    import Manufacturer = Model.Manufacturer;
    import ProductCategory = Model.ProductCategory;

    export class ProductVariantsManufacturersDataTemplate extends ProductVariantsDataTemplate implements IDataTemplate {
        get collection() {
            return this.productCategories;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options);

            this.productVariants.removeListener('sync', super.onVariantChange);
            this.productVariants.on('sync', this.onVariantChange.bind(this));

            this.productCategories.removeParent();
            this.productVariants.removeParent();

            this.manufacturers.setParentCollection(this.productCategories, CoreManufacturersToProductCatsStrategy);
            this.productVariants.setParentCollection(this.manufacturers, ProductVariantToManufacturerStrategy);
        }

        protected onVariantChange(models: CollectionModel<Variant>[], dataService: Meevo.Components.BaseClasses.IDataService) {
            let realManufacturers = {};
            for (const variant of this.productVariants.responseList) {
                let key = `${variant.categoryId}${variant.manufacturerId}`;
                if (realManufacturers[key]) {
                    continue;
                }
                let manufacturer = this.manufacturers.responseList.find(man => man.id == variant.manufacturerId);
                if (manufacturer) {
                    let clone = _(manufacturer).clone();
                    clone.categoryId = variant.categoryId;
                    realManufacturers[key] = clone;
                }
            }
            this.manufacturers.handleResponse(Object.keys(realManufacturers).map(key => realManufacturers[key]));
            this.productVariants.handleResponse(this.productVariants.responseList);
        }
    }
}